import React from 'react';
import * as S from './LinkText.styles';
const LinkText = ({
  href,
  children,
  target,
  rel,
  className
}) => /*#__PURE__*/React.createElement(S.Root, {
  className: className,
  target: target,
  rel: rel,
  href: href || '',
  passHref: true
}, children);
export default LinkText;